import { useLanguage } from "../LanguageContext";
import { useUi } from "../UiContext";

export function PrivacyDialog() {
	const { text } = useLanguage();
	const { privacyOpen, closePrivacy } = useUi();

	if (!privacyOpen) return null;

	return (
		<div className="overlay overlay-center" onClick={closePrivacy}>
			<div
				className="privacy-card"
				role="dialog"
				aria-modal="true"
				aria-labelledby="privacy-title"
				onClick={(event) => event.stopPropagation()}
			>
				<div className="popup-head">
					<h2 id="privacy-title">{text.privacy.title}</h2>
					<button type="button" className="ghost-btn" onClick={closePrivacy}>
						{text.privacy.close}
					</button>
				</div>
				<p className="privacy-updated">{text.privacy.updated}</p>
				<div className="privacy-body">
					{text.privacy.body.map((paragraph) => (
						<p key={paragraph}>{paragraph}</p>
					))}
				</div>
			</div>
		</div>
	);
}

export function Notice() {
	const { notice } = useUi();
	if (!notice) return null;
	return <div className="notice">{notice}</div>;
}
